<template>
    <div>
        <div class="n_record">
            <ul>
                <li v-for='item in integralList' :key='item.key'>
                    <span>
                        <b class="fl"> {{item.go_rmb}}元</b>
                        <em>付款成功</em>
                    </span>
                    <p>
                        积分：<strong> {{item.getdh}}</strong>
                    </p>
                    <p>
                        收款方：<strong> {{item.seller_name}}</strong>
                    </p>
                    <p>
                        付款单号：<strong> {{item.order_parent_sn}}</strong>
                    </p>
                    <p>
                        付款时间：<strong> {{item.pay_time}} </strong>
                    </p>
                </li>

            </ul>


        </div>

        <!--  无数据显示  -->
        <div class="null_data">
            <p v-if="!integralList.length" class="nodateimg">没有数据~</p>
            <p v-if="integralList.length > 6 && finished">暂无更多数据~</p>
        </div>
    </div>
</template>
<script>
    import { sendRequest } from "@/assets/public";
    export default {
        data() {
            return {

                integralList: [],
                page: 1, //页码
                isNodata: false, //是否显示缺省提示
                finished: false, //列表是否加载完毕
                offsetTop: 0,

            }
        },
        mounted() {
            this.accountRecord();
            window.addEventListener('scroll', this.handScroll)
        },
        methods: {
            handScroll() {

                if ((document.documentElement.scrollTop + window.innerHeight) >= document.body.scrollHeight) {
                    this.accountRecord();
                }
            },
            async accountRecord() {
                let that = this;
                if (!this.finished) {
                    let params = {
                        page: that.page,
                    };
                    let res = await sendRequest("tonglian/settleAccountRecord", params);

                    that.integralList = that.integralList.concat(...res.content.data);
                    if (res.content.data.length < 10) {
                        that.finished = true;
                    }
                    that.page++;

                }
            },

        },

    }
</script>
<style scoped>
    .n_record {
        width: 15rem;
        margin-top: 0.4rem;
        background: #fff;
        overflow: hidden;
    }

    .n_record ul {
        width: 13.4rem;
        padding: 0 0.8rem
    }

    .n_record ul li {
        border-bottom: 1px solid #ddd;
    }

    .n_record ul li:last-child {
        border-bottom: none;
    }

    .n_record ul li span {
        display: block;
        color: #333333;
        font-size: 0.6rem;
        height: 1.76rem;
        line-height: 1.76rem;
    }

    .n_record ul li span b {
        font-weight: bolder;
    }

    .n_record ul li em {
        color: #666;
        font-size: 0.48rem;
        float: right;
    }

    .n_record ul li p {
        display: block;
        color: #666666;
        font-size: 0.48rem;
        padding-bottom: 0.6rem;
    }

    .n_record ul li p strong {
        color: #333333;
        font-size: 0.6rem;
        font-weight: bolder;
    }

    .n_record_null {
        width: 15rem;
        text-align: center;
        padding-top: 3rem;
    }

    .n_record_null img {
        width: 6.7rem;
        height: 5.2rem;
    }

    .n_record_null p {
        color: #CCCCCC;
        font-size: 0.6rem;
        padding-top: 1rem;
    }

    .null_data {
        text-align: center;
        font-size: 0.56rem;
        padding-top: 0.4rem;
    }

    .nodateimg {
        background: url("http://statics.7dingdong.com/static/wx_program_img/integral_mall/queshengye.png") no-repeat center center;
        background-size: 11.94rem 7.64rem;
        padding-top: 11.94rem;
    }
</style>